import React from 'react';

import { isPhone } from '@helpers';
import Details from './index';

export default (props) => {
  return <Details {...{ ...props, mode: isPhone ? 'LIST' : 'FULL' }} />;
};
